import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dfc186c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center-landing-container" }
const _hoisted_2 = { id: "thesis" }
const _hoisted_3 = { id: "thesis-content" }
const _hoisted_4 = {
  id: "thesis-title",
  class: "thesis-row no-select"
}
const _hoisted_5 = { class: "header-part" }
const _hoisted_6 = { class: "header-part" }
const _hoisted_7 = { class: "thesis-row no-select" }
const _hoisted_8 = { id: "description" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thesis-demo" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "560",
    height: "315",
    src: "https://www.youtube.com/embed/sOnNywmV69E",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  })
], -1))
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"button-row show\" data-v-dfc186c8><span class=\"join-beta-button\" data-v-dfc186c8><a class=\"beta-signup\" target=\"_blank\" href=\"https://6rf461aomqj.typeform.com/to/IIDgLYto\" data-v-dfc186c8>Join Beta</a></span></div><div class=\"button-row hide\" data-v-dfc186c8><span class=\"join-beta-button\" data-v-dfc186c8><a class=\"beta-signup\" href=\"/about\" data-v-dfc186c8>About</a></span></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.header_row1), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.header_row2), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.description), 1)
        ]),
        _hoisted_9,
        _hoisted_10
      ])
    ])
  ]))
}